import { useState, useCallback, useRef } from 'react';

export type ToastLevel = 'error' | 'success' | 'warning';

export interface Toast {
  id: number;
  message: string;
  level: ToastLevel;
}

export function useToast(autoDismissMs = 8000) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const nextId = useRef(0);

  const show = useCallback(
    (message: string, level: ToastLevel = 'error') => {
      const id = nextId.current++;
      setToasts((prev) => [...prev, { id, message, level }]);
      if (autoDismissMs > 0) {
        setTimeout(() => {
          setToasts((prev) => prev.filter((t) => t.id !== id));
        }, autoDismissMs);
      }
    },
    [autoDismissMs],
  );

  const dismiss = useCallback((id: number) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, show, dismiss };
}
